import { Option } from "@/shared/components";

export const dossierOmschrijvingen = [
    "Defecte reizigerstrein",
    "Gestrande reizigerstrein",
    "Defect materieel",
    "Defecte trein",
    "Defecte goederentrein",
    "Defect spoor",
    "Defecte bovenleiding",
    "Aanrijding persoon",
    "Aanrijding object",
    "Aanrijding dier",
    "Aanrijding infra",
    "Aanrijding overig",
    "Sectiestoring",
    "Wisselstoring",
    "Verstoring treindienst",
    "Brugstoring",
    "Seinstoring",
    "Rijrichting storing",
    "Overwegstoring",
    "Stroomstoring",
    "ICT storing",
    "Opgeheven internationale trein",
    "Hinder buurland",
    "QuickScan",
    "Uitloop werkzaamheden",
    "BUTA",
    "Spoorverzakking/Knik in spoor",
    "Object spoor",
    "Object bovenleiding",
    "Persoon op/in het spoor",
    "Lijkvinding",
    "Logistieke problemen",
    "Omleiding trein",
    "Dier op/in spoor",
    "Brand/Rook",
    "Test",
    "Weer/Omgeving",
    "Assistentie hulpdiensten",
    "Reizigers gedrag",
    "Onbekend",
    "Aanrijding brug/viaduct",
    "Staking",
];

export const dossierOmschrijvingenOptions: Option[] = [...dossierOmschrijvingen]
    .sort((a, b) => a.localeCompare(b, "nl"))
    .map((omschrijving) => ({
        value: omschrijving,
        label: omschrijving,
    }));
